module.exports = "<div class=modal-header> <h3 class=modal-title> <i class=\"icon iconfont icon-tishi i-icon-primary\"></i>{{ config.title }} </h3> <div class=\"modal-body modal-alert-body\"> <div class=modal-body-content>{{ config.content }}</div> </div> <div class=\"modal-footer modal-alert-footer\"> <button class=\"btn btn-md btn-primary\" ng-click=hideModal()> {{ config.btnText || '知道了' }} </button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/outputManage/taxFilling/collectionExport/view/collection-tip.html
// module id = qmLZ
// module chunks = 0